import axios from 'axios';
import { Component } from "react";
import { baseUrl, config } from './index.js';

export default class AnnouncementService extends Component {
  static createAnnouncement = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/create_announce?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

}
